export const formatPrice = (price) => {
  if (price >= 1000) {
    return (price / 1000).toLocaleString("id-ID") + "k";
  }
  return price?.toLocaleString("id-ID") ?? "0";
};
